import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import { Card } from "@/components/ui/Card";

interface AuthPageProps {
  title: string;
  subtitle: string;
  footer: ReactNode;
  children: ReactNode;
}

export function AuthPageShell({ title, subtitle, footer, children }: AuthPageProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-paper px-6 py-16">
      <Link to="/" className="mb-8 font-display text-xl text-ink">
        Callback
      </Link>
      <Card className="w-full max-w-sm p-8">
        <h1 className="font-display text-2xl text-ink">{title}</h1>
        <p className="mt-1 text-sm text-ink-soft">{subtitle}</p>
        <div className="mt-6">{children}</div>
        <p className="mt-6 text-center text-sm text-ink-soft">{footer}</p>
      </Card>
    </div>
  );
}
